import { render, staticRenderFns } from "./UpdateUserInfoModal.vue?vue&type=template&id=c4c15aae&scoped=true&"
import script from "./UpdateUserInfoModal.vue?vue&type=script&lang=js&"
export * from "./UpdateUserInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateUserInfoModal.vue?vue&type=style&index=0&id=c4c15aae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c15aae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VDivider,VForm})
